import { Divider, FormControl, Grid, ListSubheader, MenuItem, Select, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../../../../common/GeneralUtils';
import { WorkshopCircle } from '../../../../../common/ui/WorkshopCircle';
import { useAuth } from '../../../../../session/InternalAuthProvider';
import { AccountData } from '../../../../../api';

export const ChooseWorkshopSelect = ({
  orderPages,
  editOrderState,
  setOrderPage,
  setExpandedPanel,
  coveredOrderPageIds,
}: {
  orderPages: any[];
  editOrderState: any;
  setOrderPage: (id: string) => void;
  setExpandedPanel: (panel: any) => void;
  coveredOrderPageIds?: string[];
}) => {
  const theme = useTheme();
  const language = useLanguage();
  const { t } = useTranslation();
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;

  const hasFilter = !!coveredOrderPageIds?.length;
  const covered = hasFilter ? orderPages.filter((x: any) => coveredOrderPageIds.includes(x.id)) : [];
  const others = hasFilter ? orderPages.filter((x: any) => !coveredOrderPageIds.includes(x.id)) : orderPages;

  const renderCoveredItem = (x: any) => (
    <MenuItem key={`ChooseWorkshopSelect-${x.id}`} value={x.id}>
      <Grid container alignItems="center" gap={1}>
        <WorkshopCircle account={account} orderPageId={x.id} language={language} />
        <span>{x.label[language]}</span>
      </Grid>
    </MenuItem>
  );

  const renderOtherItem = (x: any) => (
    <MenuItem key={`ChooseWorkshopSelect-${x.id}`} value={x.id}>
      <Grid container alignItems="center" gap={1}>
        <WorkshopCircle account={account} orderPageId={x.id} language={language} />
        <span style={hasFilter ? { color: theme.palette.text.secondary } : undefined}>{x.label[language]}</span>
      </Grid>
    </MenuItem>
  );

  return (
    <FormControl fullWidth>
      <Select
        sx={{
          minHeight: 60,
          borderRadius: '8px',
          fontSize: 16,
          fontWeight: 600,
          '& .MuiOutlinedInput-notchedOutline': { borderColor: 'divider' },
        }}
        value={editOrderState.orderPage.id}
        renderValue={() => (
          <Grid container alignItems="center" gap={1}>
            <WorkshopCircle account={account} orderPageId={editOrderState.orderPage.id} language={language} />
            <Grid item>{editOrderState.orderPage.label[language]}</Grid>
          </Grid>
        )}
        onChange={(event) => {
          setOrderPage(event.target.value);
          setExpandedPanel(undefined);
        }}>
        {covered.length > 0 && [
          <ListSubheader key="covered-header">{t('passes.included_in_pass')}</ListSubheader>,
          ...covered.map(renderCoveredItem),
          others.length > 0 && <Divider key="divider" />,
        ]}
        {hasFilter && others.length > 0 && (
          <ListSubheader key="others-header" sx={{ color: 'text.disabled' }}>
            {t('passes.other_workshops')}
          </ListSubheader>
        )}
        {others.map(renderOtherItem)}
      </Select>
    </FormControl>
  );
};
